module.exports = __webpack_public_path__ + "img/logo-footer-co-gov.45015bd9.svg";